var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalendarStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4.5C20.5 4.10218 20.342 3.72064 20.0607 3.43934C19.7794 3.15804 19.3978 3 19 3H16V1.5H14.5V3H8.5V1.5H7V3H4C3.60218 3 3.22064 3.15804 2.93934 3.43934C2.65804 3.72064 2.5 4.10218 2.5 4.5V19.5C2.5 19.8978 2.65804 20.2794 2.93934 20.5607C3.22064 20.842 3.60218 21 4 21H7V19.5H4V4.5H7V6H8.5V4.5H14.5V6H16V4.5H19V9H20.5V4.5Z",
    fill: "#030712"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 11.25L17.1617 14.9535L21.25 15.5468L18.25 18.4298L19 22.5L15.25 20.5785L11.5 22.5L12.25 18.4298L9.25 15.5468L13.45 14.9535L15.25 11.25Z",
    fill: "#030712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarStar);
export default __webpack_public_path__ + "static/media/ic-calendar-star.b8e33f467a494ad3522b51cf44bd9a23.svg";
export { ForwardRef as ReactComponent };